import { HelpContent } from "../../../../src/components/help/content";
import { CommonFAQ } from "../../../../src/components/common/faq";
import { Footer } from "../../../../src/components/common/footer";
import * as React from 'react';
export default {
  HelpContent,
  CommonFAQ,
  Footer,
  React
};